import React from "react";
import { Bannerdata,OverviewData,LatestUpdate } from "./data";
import BannerNews from "../../../../components/body/topnewsupdates/newsupdates/BannerNews";
import Navbar from "../../../../components/Navbar/Navbar";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";
import Heading from "../../../../components/body/topnewsupdates/newsupdates/Heading";
import Slider_card from "../../../../components/body/topnewsupdates/Slider-Card";

const News_Update3 = () => {
  return (
    <div>
      <Navbar />
      <BannerNews Bannerdata={Bannerdata} />
      <Heading OverviewData={OverviewData} />
      <Slider_card sliderData={LatestUpdate} />
      <Main_Footer />
    </div>
  )
}

export default News_Update3